import React, { useState } from 'react';
import HelpModal from './HelpModal';

const HelpIcon = ({ title, content, size = 18 }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="inline-flex items-center justify-center rounded-full bg-white/10 backdrop-blur-md border border-white/20 hover:border-[#6F42EA] transition-all cursor-help"
        style={{
          width: `${size}px`,
          height: `${size}px`,
          boxShadow: '0 0 8px rgba(120, 90, 255, 0.35)'
        }}
        aria-label="Help"
      >
        <span className="text-white text-xs font-bold" style={{ fontSize: `${size * 0.65}px` }}>?</span>
      </button>
      
      <HelpModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        title={title}
      >
        <div className="text-white text-xl leading-loose space-y-5" style={{ position: 'relative', zIndex: 10 }}>
          {content}
        </div>
      </HelpModal>
    </>
  );
};

export default HelpIcon;
